import React, { Suspense, lazy } from "react";
import { Branch } from "@/app/branchs/branchs.type";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import { t } from "i18next";
import LazyLoadComponent from "@/pages/Kpis/Componennts/LazyLoad";

const EarningsTotalBranchChart = lazy(
  () => import("../Charts/EarningsTotalBranchChart")
);
const EarningsTotalBranchByDaysChart = lazy(
  () => import("../Charts/EarningsTotalBranchByDaysChart")
);
const EarningsBranchSourceChart = lazy(
  () => import("../Charts/EarningsBranchSourceChart")
);
const EarningsBranchSourceDaysChart = lazy(
  () => import("../Charts/EarningsBranchSourceDaysChart")
);
const EarningsBranchChart = lazy(() => import("../Charts/EarningsBranchChart"));
const EarningsBranchDaysChart = lazy(
  () => import("../Charts/EarningsBranchDaysChart")
);
const EarningsStoreBranchChart = lazy(
  () => import("../Charts/EarningsStoreBranchChart")
);
const EarningsStoreBranchDaysChart = lazy(
  () => import("../Charts/EarningsStoreBranchDaysChart")
);
const EarningsStoreCategoryChart = lazy(
  () => import("../Charts/EarningsStoreCategoryChart")
);
const EarningsStoreCategoryDaysChart = lazy(
  () => import("../Charts/EarningsStoreCategoryDaysChart")
);
const EarningsSPBondsChart = lazy(
  () => import("../Charts/EarningsSPBondsChart")
);
const EarningsSPBondsDaysChart = lazy(
  () => import("../Charts/EarningsSPBondsDaysChart")
);
const EarningsBondsChart = lazy(() => import("../Charts/EarningsBondsChart"));
const EarningsBondsDaysChart = lazy(
  () => import("../Charts/EarningsBondsDaysChart")
);
const EarningsFreeCoursesChart = lazy(
  () => import("../Charts/EarningsFreeCoursesChart")
);
const EarningsFreeCoursesDaysChart = lazy(
  () => import("../Charts/EarningsFreeCoursesDaysChart")
);

export type RevenueProps = {
  branches: Branch[];
};

const RevenueComponent: React.FC<RevenueProps> = ({ branches }) => {
  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.main_earnings")}
          description={t("user.views.main_message_earnings")}
        />
      </div>
      <div className="grid gap-4 p-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsTotalBranchChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsTotalBranchByDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBranchSourceChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBranchSourceDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBranchChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBranchDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsStoreBranchChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsStoreBranchDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsStoreCategoryChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsStoreCategoryDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsSPBondsChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsSPBondsDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBondsChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsBondsDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsFreeCoursesChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
        <LazyLoadComponent>
          <Suspense fallback={<div></div>}>
            <div className="bg-white shadow rounded-lg p-4">
              <EarningsFreeCoursesDaysChart branches={branches} />
            </div>
          </Suspense>
        </LazyLoadComponent>
      </div>
    </>
  );
};

export default RevenueComponent;
